import { Pill } from "@gadgetinc/widgets/src/components/Pill";
import { ReactIcon } from "@gadgetinc/widgets/src/icons/ReactIcon";
import { SecurityLockIcon } from "@gadgetinc/widgets/src/icons/SecurityLockIcon";
import { ThirdPartyIcon } from "@gadgetinc/widgets/src/icons/ThirdPartyIcon";
import { ShopifyIcon } from "@gadgetinc/widgets/src/icons/brands/ShopifyIcon";
import { useStyletron } from "baseui";
import { colors } from "baseui/tokens";
import React from "react";

export type AppTemplateTagType =
  | "auth"
  | "checkout-extension"
  | "embedded"
  | "openai"
  | "customer-extension"
  | "theme-extension"
  | "shopify-cart-transform-function"
  | "react"
  | "react-router"
  | "remix"
  | "carleton-hackathon-2025";

const ShopifyPill = (props: { children: React.ReactNode }) => {
  const [_css, $theme] = useStyletron();

  return (
    <Pill
      $color={{ color: colors.gray600, backgroundColor: "#eff5df" }}
      $style={{
        gap: $theme.sizing.scale200,
      }}
    >
      <ShopifyIcon /> {props.children}
    </Pill>
  );
};

export const AppTemplateTag = (props: { tag: AppTemplateTagType }) => {
  const [_css, $theme] = useStyletron();

  switch (props.tag) {
    case "checkout-extension":
      return <ShopifyPill>Checkout UI extension</ShopifyPill>;
    case "customer-extension":
      return <ShopifyPill>Customer UI extension</ShopifyPill>;
    case "theme-extension":
      return <ShopifyPill>Theme extension</ShopifyPill>;
    case "shopify-cart-transform-function":
      return <ShopifyPill>Cart transform function</ShopifyPill>;
    case "embedded":
      return (
        <Pill
          $color={{ color: colors.gray600, backgroundColor: "#eff5df" }}
          $style={{
            gap: $theme.sizing.scale200,
          }}
        >
          <ShopifyIcon /> Embedded app
        </Pill>
      );
    case "react":
      return (
        <Pill
          $color={{ color: colors.gray600, backgroundColor: "#00BCD426" }}
          $style={{
            gap: $theme.sizing.scale200,
          }}
        >
          <ReactIcon color="#06bcd4" /> React
        </Pill>
      );
    // todo: add pill for remix
    case "auth":
      return (
        <Pill
          $color={{
            backgroundColor: $theme.colors.alpha100,
            color: colors.gray600,
          }}
          $style={{
            gap: $theme.sizing.scale200,
          }}
        >
          <SecurityLockIcon /> Auth
        </Pill>
      );
    case "openai":
      return (
        <Pill
          $color={{
            backgroundColor: colors.gray600,
            color: colors.white,
          }}
          $style={{
            gap: $theme.sizing.scale200,
          }}
        >
          <ThirdPartyIcon $color={$theme.colors.white} type={"openai"} /> OpenAI
        </Pill>
      );
    default:
      return null;
  }
};
